import { forwardRef } from 'react';
import { Slider as RadixSlider } from '@radix-ui/themes';
import type { RadixSliderProps } from '@/types/radix-ui';

/**
 * Slider component - wrapper around Radix UI Slider
 * Provides range input controls for selecting numeric values
 */
export type SliderProps = RadixSliderProps;

const Slider = forwardRef<HTMLSpanElement, SliderProps>((props, ref) => {
  return <RadixSlider ref={ref} {...props} />;
});

Slider.displayName = 'Slider';

export { Slider };
